import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-culturele-giften',
  templateUrl: './tekst-aftrekbare-culturele-giften.component.html',
  styleUrls: ['./tekst-aftrekbare-culturele-giften.component.scss'],
})
export class TekstAftrekbareCultureleGiftenComponent {}
